import { render } from "./LogoutPage.vue?vue&type=template&id=03a943d0&scoped=true&ts=true"
import script from "./LogoutPage.vue?vue&type=script&lang=ts"
export * from "./LogoutPage.vue?vue&type=script&lang=ts"

import "./LogoutPage.vue?vue&type=style&index=0&id=03a943d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a943d0"]])

export default __exports__